/* eslint-disable space-before-function-paren */
// @flow
import moment from 'moment';
import { isEmpty, upperFirst } from 'lodash';

import config from 'Config';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import {
  WIDGET_WEBCALLBACK_OPENING_HOURS,
  WIDGET_WEBCALLBACK_SCHEDULE_CALL,
} from 'Utils/request/requestDictionary';

const ACCOUNT_ID = config.get('freespee.accountId');
const AGENT_NUMBER = config.get('freespee.agentNumber');
const AGENT_NUMBER_ID = config.get('freespee.agentNumberId');
const CALLER_ID = config.get('freespee.callerId') || '';
const CUSTOMER_ID = config.get('freespee.customerId');

const FREESPEE_DATE_FORMAT = 'YYYY-MM-DD';
const FREESPEE_TIME_FORMAT = 'HH:mm:ss';
const FREESPEE_DATETIME_FORMAT = `${FREESPEE_DATE_FORMAT} ${FREESPEE_TIME_FORMAT}`;
const DISPLAY_TIME_FORMAT = 'HH:mm';
const RETRIES = '2';
const RETRY_INTERVAL = '120';

export const ASAP_TIME = 'ASAP';

export const CALLBACK_STATUS = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  ERROR: 'error',
};

export const PHONE_PREFIXES = [
  { countryCode: 'AL', value: 355, name: '+355 (AL)' },
  { countryCode: 'AR', value: 54, name: '+54 (AR)' },
  { countryCode: 'AT', value: 43, name: '+43 (AT)' },
  { countryCode: 'AU', value: 61, name: '+61 (AU)' },
  { countryCode: 'BA', value: 387, name: '+387 (BA)' },
  { countryCode: 'BE', value: 32, name: '+32 (BE)' },
  { countryCode: 'BG', value: 359, name: '+359 (BG)' },
  { countryCode: 'BR', value: 55, name: '+55 (BR)' },
  { countryCode: 'CA', value: 1, name: '+1 (CA)' },
  { countryCode: 'CH', value: 41, name: '+41 (CH)' },
  { countryCode: 'CL', value: 56, name: '+56 (CL)' },
  { countryCode: 'CN', value: 86, name: '+86 (CN)' },
  { countryCode: 'CY', value: 357, name: '+357 (CY)' },
  { countryCode: 'CZ', value: 420, name: '+420 (CZ)' },
  { countryCode: 'DE', value: 49, name: '+49 (DE)' },
  { countryCode: 'DK', value: 45, name: '+45 (DK)' },
  { countryCode: 'EE', value: 372, name: '+372 (EE)' },
  { countryCode: 'EG', value: 20, name: '+20 (EG)' },
  { countryCode: 'ES', value: 34, name: '+34 (ES)' },
  { countryCode: 'FI', value: 358, name: '+358 (FI)' },
  { countryCode: 'FR', value: 33, name: '+33 (FR)' },
  { countryCode: 'GB', value: 44, name: '+44 (GB)' },
  { countryCode: 'GI', value: 350, name: '+350 (GI)' },
  { countryCode: 'GR', value: 30, name: '+30 (GR)' },
  { countryCode: 'HK', value: 852, name: '+852 (HK)' },
  { countryCode: 'HR', value: 385, name: '+385 (HR)' },
  { countryCode: 'HU', value: 36, name: '+36 (HU)' },
  { countryCode: 'IE', value: 353, name: '+353 (IE)' },
  { countryCode: 'IL', value: 972, name: '+972 (IL)' },
  { countryCode: 'IN', value: 91, name: '+91 (IN)' },
  { countryCode: 'IR', value: 98, name: '+98 (IR)' },
  { countryCode: 'IS', value: 354, name: '+354 (IS)' },
  { countryCode: 'IT', value: 39, name: '+39 (IT)' },
  { countryCode: 'JP', value: 81, name: '+81 (JP)' },
  { countryCode: 'LB', value: 961, name: '+961 (LB)' },
  { countryCode: 'LT', value: 370, name: '+370 (LT)' },
  { countryCode: 'LU', value: 352, name: '+352 (LU)' },
  { countryCode: 'LV', value: 371, name: '+371 (LV)' },
  { countryCode: 'MC', value: 377, name: '+377 (MC)' },
  { countryCode: 'MD', value: 373, name: '+373 (MD)' },
  { countryCode: 'MT', value: 356, name: '+356 (MT)' },
  { countryCode: 'MX', value: 52, name: '+52 (MX)' },
  { countryCode: 'NL', value: 31, name: '+31 (NL)' },
  { countryCode: 'NO', value: 47, name: '+47 (NO)' },
  { countryCode: 'NZ', value: 64, name: '+64 (NZ)' },
  { countryCode: 'PA', value: 507, name: '+507 (PA)' },
  { countryCode: 'PE', value: 51, name: '+51 (PE)' },
  { countryCode: 'PK', value: 92, name: '+92 (PK)' },
  { countryCode: 'PL', value: 48, name: '+48 (PL)' },
  { countryCode: 'PT', value: 351, name: '+351 (PT)' },
  { countryCode: 'RO', value: 40, name: '+40 (RO)' },
  { countryCode: 'RS', value: 381, name: '+381 (RS)' },
  { countryCode: 'RU', value: 7, name: '+7 (RU)' },
  { countryCode: 'SE', value: 46, name: '+46 (SE)' },
  { countryCode: 'SG', value: 65, name: '+65 (SG)' },
  { countryCode: 'SI', value: 386, name: '+386 (SI)' },
  { countryCode: 'SK', value: 421, name: '+421 (SK)' },
  { countryCode: 'TH', value: 66, name: '+66 (TH)' },
  { countryCode: 'TR', value: 90, name: '+90 (TR)' },
  { countryCode: 'US', value: 1, name: '+1 (US)' },
  { countryCode: 'ZA', value: 27, name: '+27 (ZA)' },
];

type OpeningTimesPerDay = {
  [string]: {
    from: string,
    to: string,
  }[],
};

type GetTimeSlotsProps = {
  openingTimesPerDay: null | OpeningTimesPerDay,
  i18n: *,
};

type Slot = {
  value: string,
  name: string,
};

type TimesSlots = Array<{
  ...$Exact<Slot>,
  slots: Array<Slot>,
}>;

function hasNameInSlots(slots: { value: string, name: string }[], name: string): boolean {
  return slots.some(slot => slot.name === name);
}

export const getTimeSlots = ({ openingTimesPerDay, i18n }: GetTimeSlotsProps): TimesSlots => {
  if (!openingTimesPerDay) return [];

  const openDays = Object.keys(openingTimesPerDay);
  const { asap, today, tomorrow } = i18n;
  const maxDaysInTheFuture = 7;
  const daysOfWeek = [...Array(maxDaysInTheFuture).keys()].map(day => {
    return moment()
      .utc()
      .add(day, 'd')
      .locale('en')
      .format('ddd')
      .toLowerCase();
  });

  return [...Array(maxDaysInTheFuture).keys()]
    .filter(day => {
      const dayOfWeek = moment()
        .utc()
        .add(day, 'd')
        .locale('en')
        .format('ddd');
      return openDays.includes(dayOfWeek.toLowerCase());
    })
    .map((day, idx) => {
      const slots = [];
      const dayLabel = daysOfWeek[day];
      const openingTimes = openingTimesPerDay[dayLabel];
      const now = moment.utc().add(day, 'd');
      const dayOfWeek = now.calendar(null, {
        sameDay: `[${upperFirst(today)}]`,
        nextDay: `[${upperFirst(tomorrow)}]`,
        nextWeek: 'dddd',
        sameElse: 'dddd',
      });

      openingTimes?.forEach(openingTime => {
        const [beginHour, beginMinute] = openingTime.from.split(':');
        const begin = moment
          .utc()
          .startOf('day')
          .hour(parseInt(beginHour, 10))
          .minute(parseInt(beginMinute, 10));

        const [endHour, endMinute] = openingTime.to.split(':');
        const end = moment
          .utc()
          .startOf('day')
          .hour(parseInt(endHour, 10))
          .minute(parseInt(endMinute, 10));

        let current = begin;
        if (idx === 0) {
          current = moment
            .max(now, begin)
            .add(1, 'h')
            .startOf('h');

          if (!hasNameInSlots(slots, upperFirst(asap))) {
            slots.push({ value: ASAP_TIME, name: upperFirst(asap) });
          }
        }

        while (current.isBefore(end)) {
          const value = current.format(FREESPEE_DATETIME_FORMAT);
          const slotStart = current.format(DISPLAY_TIME_FORMAT);
          current.add(30, 'm');
          const slotEnd = current.format(DISPLAY_TIME_FORMAT);
          const name = `${slotStart} - ${slotEnd}`;
          if (!hasNameInSlots(slots, name)) {
            slots.push({ value, name });
          }
        }
      });

      return {
        value: now.format(FREESPEE_DATE_FORMAT),
        name: upperFirst(dayOfWeek),
        slots,
      };
    });
};

type FetchOpeningHoursProps = {
  setOpeningTimesPerDay: (openingTimesPerDay: OpeningTimesPerDay) => void,
};

function concatIntervalsPerDay(openingTimesPerDay, weekday): OpeningTimesPerDay {
  if (!weekday?.intervals) return openingTimesPerDay;
  const openingTimeInterval = weekday?.intervals?.map(interval => ({
    from: interval?.openingTime,
    to: interval?.closingTime,
  }));
  if (openingTimesPerDay[(weekday?.day)]) {
    openingTimesPerDay[(weekday?.day)] = openingTimesPerDay[(weekday?.day)].concat(
      openingTimeInterval,
    );
  } else {
    openingTimesPerDay[(weekday?.day)] = openingTimeInterval;
  }
  return openingTimesPerDay;
}

export const fetchOpeningHours = async (
  { setOpeningTimesPerDay }: FetchOpeningHoursProps,
  appContext: AppContext,
) => {
  const query = `query {
    webCallbackHours(customerId: "${CUSTOMER_ID}") {
      weekdays {
        day
        intervals {
          openingTime
          closingTime
        }
      }
    }
  }`;
  try {
    const data = await graphQLClient.runQuery(query, appContext, {
      requestName: WIDGET_WEBCALLBACK_OPENING_HOURS,
    });
    const openingTimesPerDay = data.webCallbackHours.weekdays.reduce(concatIntervalsPerDay, {});
    if (openingTimesPerDay && !isEmpty(openingTimesPerDay))
      setOpeningTimesPerDay(openingTimesPerDay);
  } catch (error) {
    // No need to handle this
  }
};

type SubmitCallbackProps = {
  scheduled: ?string,
  requesterNumber: string,
  setCallbackStatus: (status: string) => void,
  setSubmitting: (status: boolean) => void,
};

export const submitCallback = async (
  { scheduled, requesterNumber, setCallbackStatus, setSubmitting }: SubmitCallbackProps,
  appContext: AppContext,
) => {
  const schedule = scheduled ? `"${scheduled}"` : 'null';
  const query = `mutation {
    webCallback(
      agentNumber: "${AGENT_NUMBER}",
      callerId: "${CALLER_ID}",
      customerId: "${CUSTOMER_ID}",
      webCallbackInput: {
        requesterNumber: "${requesterNumber}",
        scheduled: ${schedule},
        retries: ${RETRIES},
        retryInterval: ${RETRY_INTERVAL}
      }) {
      ... on WebCallback {
        id
        type
        agentNumber
        callerId
        requesterNumber
        retries
        retryInterval
      }
      ... on WebCallbackError {
        errorCode
        errorDescription
        errorKey
        errorValue        
      }
    }
  }`;
  try {
    const { webCallback } = await graphQLClient.runNoCacheQuery(query, appContext, {
      requestName: WIDGET_WEBCALLBACK_SCHEDULE_CALL,
    });
    if (webCallback.errorCode) {
      setCallbackStatus(CALLBACK_STATUS.ERROR);
    } else {
      setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
    }
  } catch (error) {
    setCallbackStatus(CALLBACK_STATUS.ERROR);
  } finally {
    setSubmitting(false);
  }
};

type RequestCallbackProps = {
  scheduled: ?string,
  requesterNumber: string,
  requesterNumberPrefix: number,
  setCallbackStatus: (status: string) => void,
  setSubmitting: (status: boolean) => void,
};

export const requestCallback = ({
  scheduled,
  requesterNumber,
  requesterNumberPrefix,
  setCallbackStatus,
  setSubmitting,
}: RequestCallbackProps) => {
  try {
    window.__fs_dncs_instance.requestCallback(
      ACCOUNT_ID, // AVD_ID
      AGENT_NUMBER_ID, // Answering_number_id
      requesterNumberPrefix, // Country_code
      requesterNumber, // customer_phonenr
      CALLER_ID, // caller_id
      {}, // custom_*
      scheduled ? scheduled : null, // call_time,
      (ref, data) => {
        const { status, call_uuid: callId } = data;
        if (status === 'ok' && callId) {
          setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
        } else {
          setCallbackStatus(CALLBACK_STATUS.ERROR);
        }
        setSubmitting(false);
      },
      null,
      RETRIES, // retries
    );
  } catch (error) {
    setCallbackStatus(CALLBACK_STATUS.ERROR);
    setSubmitting(false);
  }
};
